import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c11ff16"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = {
  key: 0,
  class: "name"
}
const _hoisted_3 = {
  key: 1,
  class: "job-fields"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal_View = _resolveComponent("Modal-View")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'show-modal': _ctx.showModal }, "member"]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleModalOpen && _ctx.handleModalOpen(...args)))
    }, [
      _createElementVNode("img", {
        alt: _ctx.member.post_title,
        class: _normalizeClass({ round: _ctx.isRound }),
        src: _ctx.member.acf.image.value.url
      }, null, 10, _hoisted_1),
      (_ctx.member.acf.show_name.value && !_ctx.hideNames)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.member.post_title), 1))
        : _createCommentVNode("", true),
      (!_ctx.hideJobFields)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.showOnlyFirstJobField)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString([..._ctx.jobFields].shift().job_field), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.jobFields, (field) => {
                  return (_openBlock(), _createElementBlock("span", { key: field }, _toDisplayString(field.job_field), 1))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Modal_View, {
      email: _ctx.email,
      "fields-of-activity": _ctx.fieldsOfActivity,
      image: _ctx.image,
      "job-fields": _ctx.jobFields,
      open: _ctx.isOpen,
      phone: _ctx.phone,
      title: _ctx.member.post_title,
      showDetails: Boolean(_ctx.member.acf.show_details.value),
      showName: Boolean(_ctx.member.acf.show_name.value),
      onCloseModal: _ctx.handleModalOpen
    }, null, 8, ["email", "fields-of-activity", "image", "job-fields", "open", "phone", "title", "showDetails", "showName", "onCloseModal"])
  ], 64))
}